export const separatedNumbers = (blocks = 4, separator = '-') => window.crypto.getRandomValues(new Uint16Array(blocks)).join(separator);

// export const phoneFormatter = (number) => number.replace(new RegExp('[^\\d]', 'g'), '').replace(/^[0]/, '46').replace(/^[7]/, '467').replace(/^[9]/, '479');
export const trim = (number) => number.replace(/[^0-9]/g, '');

export const phone = {
  trim,
};

export const randomize = {
  separatedNumbers,
};

export const regscape = (s) => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // eslint-disable-line
